import axios from 'axios';
import { API_EXCEPTION_MSG } from '../../Common';
import { API_RESULT_CD, BAD_REQUEST, CommonResult, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, OK } from '../Common';

const endpoint = process.env.REACT_APP_API_URL;
const URL = `${endpoint}/hearing-info`;

export interface HearingInfoApiRequest {
  hearingId: string | null;
  scheduleStartDate: string;
  scheduleEndDate: string;
  agencyCd: string;
}

export interface HearingInfo {
  answerName: string;
  questionHeadline: string;
  questionId: string;
  sortId: string;
}

export interface HearingInfoApiResponse {
  result: CommonResult;
  hearingQuestionAnswerDtos?: HearingInfo[];
}

/**
 * ヒアリング連携情報取得API?
 * @param request リクエスト
 */
export async function getHearingInfoApi(request: HearingInfoApiRequest): Promise<HearingInfoApiResponse> {
  try {
    const { data, status } = await axios.post<HearingInfoApiResponse>(URL, request);
    switch (status) {
      case OK.status:
        return data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);
      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
      hearingQuestionAnswerDtos: [],
    };
  }
}
